<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>

<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12">
      <p-panel header="{{ 'PLANESCARGOS.LBL_INFORMACIONGENERAL' | translate}}" *ngIf="planCargo">
        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PLANESCARGOS.LBL_CODIGO' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8 "><strong>{{planCargo.codigo}}</strong></label>
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PLANESCARGOS.LBL_NOMBRE' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{planCargo.nombre}}</strong></label>
        </div>
        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'PLANESCARGOS.LBL_DESCRIPCION' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{planCargo.descripcion}}</strong></label>
        </div>
      </p-panel>
    </div>
  </div>
  <div class="grid">
    <div class="col-12">
      <p-panel header="{{ 'PLANESCARGOS.LBL_CONCEPTOS' | translate}}">
        <p-table [columns]="colConceptos"
                 [value]="planCargosConceptos" selectionMode="single" dataKey="idPlanCargoConceptos"
                 [paginator]="true" [rows]="10"  paginatorPosition="bottom">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                {{col.header}}
                <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr [pSelectableRow]="row">
              <td>{{row.conceptoFacturacion}}</td>
              <td>{{(row.codigoConvenio ? row.codigoConvenio + " - " : "")}}{{row.nombreConvenio}}</td>
              <td>{{row.tipoDatoConcepto}}</td>
              <td>{{row.codigoTipoDatoConcepto == 'PESO' ? (row.valor |dinero:2) : (row.codigoTipoDatoConcepto == 'PORC' ? (row.valor + '%') : row.valor) }}</td>
              <td>{{row.tipoIva}}</td>
              <td>{{row.formaCobroConcepto}}</td>
              <td class="text-center">
                <p-checkbox [(ngModel)]="row.indicadorHabilitado" binary="true" disabled="true"></p-checkbox>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length">
                {{ 'MSG_NOHAYREGISTROS' | translate}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-panel>
    </div>
  </div>

  <div class="grid form-footer-buttons">
    <div class="form-group col-12">
      <button icon="fa fa-arrow-left" label="{{ 'BTN_REGRESAR' | translate }}" type="button"
              pButton (click)="regresar()"></button>
    </div>
  </div>
</div>

